import { lazy } from "react";
import Loadable from "components/Loadable";

const FunctionalAreaList = Loadable(
  lazy(() => import("features/functionalArea/components/List"))
);
const FunctionalAreaPage = Loadable(
  lazy(() => import("features/functionalArea/components/Page"))
);

const routes = {
  path: "functionalArea",
  children: [
    { path: "", element: <FunctionalAreaList /> },
    { path: "add", element: <FunctionalAreaPage /> },
    { path: "edit/:functionalAreaID?", element: <FunctionalAreaPage /> },
  ],
};

export default routes;
